import { useState } from "react";
import BaseClientNew from "../helper/BaseclientNew";
import { APIEndpoints } from "../constants/APIEndpoints";
import BaseClient from "../helper/Baseclient";

const useReservationSettings = () => {
  const [reservationSettings, setReservationSettings] = useState(null);
  const [reservSettingsLoading, setReservSettingsLoading] = useState(false);

  const [foodpageReservSettings, setFoodpageReservSettings] = useState(null);
  const [reservationStatus, setReservationStatus] = useState("Disabled");

  const fetchCurrentSettings = async () => {
    try {
      setReservSettingsLoading(true);

      await BaseClientNew.get(APIEndpoints.fetchSettings, {
        onSuccess: (res) => {
          if (res && res.data) {
            setReservationSettings(res.data);
          }
        },
        onFailed: (err) => {
          console.log("Error on fetching reservation settings", err);
        },
      });
    } finally {
      setReservSettingsLoading(false);
    }
  };

  const createNewReservations = async (payload, { onSuccess, onFailed }) => {
    try {
      setReservSettingsLoading(true);

      await BaseClientNew.post(APIEndpoints.createNewSettings, payload, {
        onSuccess: onSuccess,
        onFailed: onFailed,
      });
    } finally {
      setReservSettingsLoading(false);
    }
  };

  const updateReservationSettings = async (
    payload,
    { onSuccess, onFailed }
  ) => {
    try {
      setReservSettingsLoading(true);

      await BaseClientNew.put(APIEndpoints.updateSettings, payload, {
        onSuccess: onSuccess,
        onFailed: onFailed,
      });
    } finally {
      setReservSettingsLoading(false);
    }
  };

  const getSettings = async () => {
    try {
      setReservSettingsLoading(true);
      
      const token = window.localStorage.getItem("shopCustomToken");
      if (!token || token.length === 0) {
        console.error("SHOP TOKEN MISSING!");
        return;
      }
      const header = {
        "x-shopToken": token,
      };

      await BaseClient.get(
        APIEndpoints.getSettings,
        {},
        {
          onSuccess: (res) => {
            if (res?.data?.reservationSettings) {
              setFoodpageReservSettings(res?.data?.reservationSettings);
              setReservationStatus(res?.data?.reservation);
            }
          },
          onFailed: (err) => {
            console.error("Error on fetching foodpage reserv settings!", err);
          },
          headers: header,
        }
      );
    } finally {
      setReservSettingsLoading(false);
    }
  };

  const updateSettings = async (payload, { onSuccess, onFailed }) => {
    try {
      setReservSettingsLoading(true);
      const token = window.localStorage.getItem("shopCustomToken");
      if (!token || token.length === 0) {
        console.error("SHOP TOKEN MISSING!");
        return;
      }
      const header = {
        "x-shopToken": token,
      };

      await BaseClient.put(APIEndpoints.shopUpdateSettings, payload, {
        onSuccess: onSuccess,
        onFailed: onFailed,
        headers: header,
      });
    } finally {
      setReservSettingsLoading(false);
    }
  };

  return {
    reservationSettings,
    reservSettingsLoading,
    fetchCurrentSettings,
    createNewReservations,
    updateReservationSettings,
    getSettings,
    foodpageReservSettings,
    reservationStatus,
    setReservationStatus,
    updateSettings,
  };
};

export default useReservationSettings;
